import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.map";
import "core-js/modules/es.string.link";
import React from "react";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import BranchLink from "web/react/components/branch-link/branch-link";
import { RawBranchLink } from "web/script/utils/branch-io";
import styles from "./homepage-business-value.css";
export function BusinessValueSection(_ref) {
  var section = _ref.section;
  return React.createElement("div", {
    className: styles.businessValueSection
  }, React.createElement(LazyLoadImage, {
    src: section.img_url,
    alt: section.title,
    className: styles.image
  }), React.createElement("div", {
    className: styles.textBlock
  }, React.createElement("h3", {
    className: styles.title
  }, section.title), React.createElement("p", {
    className: styles.message
  }, section.description), section.is_branch_link ? React.createElement(BranchLink, {
    title: "",
    className: styles.link,
    branchLink: RawBranchLink.Homepage,
    eventLabel: "homepage_download_badge"
  }, React.createElement("span", null, section.link_title, React.createElement(SVGIcon, {
    className: styles.chevron,
    name: "chevron"
  }))) : React.createElement("a", {
    className: styles.link,
    href: section.url
  }, section.link_title, React.createElement(SVGIcon, {
    className: styles.chevron,
    name: "chevron"
  }))));
}

function HomepageBusinessValue(_ref2) {
  var sections = _ref2.sections;
  return React.createElement("div", {
    className: styles.businessValue
  }, sections.map(function (section) {
    return React.createElement(BusinessValueSection, {
      key: section.url,
      section: section
    });
  }));
}

export default HomepageBusinessValue;